module.exports = __webpack_public_path__ + "f7b884d7215808a68732e51af2edb050.pdf";